
/* injects from baggage-loader */

import React, {Component} from 'react';
import {SwarmDataMixin} from '../../../../dev/mixins/swarmDataMixin';
import {connect} from 'react-redux';
import {SubscribeForMessages, UserProfileUpdateReceived} from "../../../../dev/actions/user";
import {GetProfile} from "../../../../dev/helpers/selectors";
import PropTypes from 'prop-types';
import {GetUserBalance} from "../../../../dev/actions/balance";
import Config from '../../../../dev/config/main';
import { UIMixin } from "../../../mixins/uiMixin";
import {Logout} from "../../../actions/login";
import { toast } from 'react-toastify';
import { ClosePopup } from '../../../actions/ui';

class ProfileHandler extends Component {

    UNSAFE_componentWillMount () {
        !(Config.messages && Config.messages.disableMessages) && this.props.dispatch(SubscribeForMessages((unSubscribe) => {
            this.unSubscribe = unSubscribe;
        }));
        Config.isPartnerIntegration && (Config.isPartnerIntegration.mode.iframe || Config.isPartnerIntegration.needToLoginFromUrl) && this.props.profile && this.activateBalanceChecker(this.props.profile);
    }
    activateBalanceChecker (profile) {
        this.checkBalanceEnabled = true;
        this.checkBalance(profile);
    }

    checkBalance (profile) {
        if (this.checkBalanceEnabled) {
            this.props.dispatch(GetUserBalance(this.props.profile || profile));
            setTimeout(this.checkBalance.bind(this, this.props.profile || profile), 30000);
        }
    }

    deactivateBalanceChecker () {
        this.checkBalanceEnabled = false;
    }

    componentWillUnmount () {
        this.unSubscribe && this.unSubscribe();
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
        let newProfileData = nextProps.profile;
        const { activePopup, profile: oldProfileData } = this.props

        if (newProfileData && (!oldProfileData || (JSON.stringify(newProfileData) !== JSON.stringify(oldProfileData)))) {
            let profile = {
                ...newProfileData,
                "currency_name": Config.main.showPointsInsteadCurrencyName ? "PTS" : newProfileData.currency_name
            };

            // balance diff check for hipay
            if (Config.main.site_id === 825) {
                if (profile.balance === 0) {
                    this.props.openPopup("userActionOK", {data: "Please charge your card before playing"})();
                    this.props.dispatch(Logout());
                } else {
                    this.props.dispatch(UserProfileUpdateReceived(profile));
                }
            } else {
                this.props.dispatch(UserProfileUpdateReceived(profile));
            }
        }
        if (!oldProfileData && newProfileData) {
            Config.isPartnerIntegration && (Config.isPartnerIntegration.mode.iframe || Config.isPartnerIntegration.needToLoginFromUrl) && !this.checkBalanceEnabled && this.activateBalanceChecker(newProfileData);
        } else if (!newProfileData && oldProfileData) {
            Config.isPartnerIntegration && (Config.isPartnerIntegration.mode.iframe || Config.isPartnerIntegration.needToLoginFromUrl) && this.checkBalanceEnabled && this.deactivateBalanceChecker();
        }
    }

    render () {
        return <input type="hidden" value={this.props.user.loggedIn}/>;
    }
}

ProfileHandler.propTypes = {
    profile: PropTypes.object,
    user: PropTypes.object,
    openPopup: PropTypes.func
};

const mapStateToProps = (state) => ({
    user: state.user,
    profile: GetProfile(state),
    activePopup: state.uiState.popup,
    reallyLoggedIn: state.user.reallyLoggedIn
})

export default connect(mapStateToProps)(SwarmDataMixin({
    Component: UIMixin({Component: ProfileHandler}),
    ComponentWillMount: function () {
        this.swarmSubscriptionRequest = {
            "source": "user",
            "what": {"profile": []}
        };
        this.swarmDataKey = "profile";
    }
}));